import { useDebounceFn, useDocumentVisibility, useInViewport } from 'ahooks'
import { getOperationName } from 'apollo-link'
import React from 'react'

import {
  GetSectionRecentUnreadCountDocument,
  GetViewerFollowingGroupsDocument,
  RequestedPostFragment,
  usePostReadMutation,
  usePostUpdatedSubscription,
} from '@/generated/graphql'

export const useReadPost = (post: RequestedPostFragment) => {
  const [readPost] = usePostReadMutation({
    refetchQueries: [
      getOperationName(GetViewerFollowingGroupsDocument)!,
      getOperationName(GetSectionRecentUnreadCountDocument)!,
    ],
  })
  const ref = React.useRef<HTMLDivElement>(null)
  const inViewPort = useInViewport(ref)
  const documentVisiblity = useDocumentVisibility()

  React.useEffect(() => {
    if (documentVisiblity !== 'visible' || post.isRead || !inViewPort || post.isViewerCreated || post.archivedAt) {
      return
    }
    readPost({ variables: { postId: post.postId } })
  }, [inViewPort, documentVisiblity])

  return ref
}

export const usePostImpactUpdate = (postId: number) => {
  const [impact, setImpact] = React.useState<number | null>(0)
  const { run: setShowImpactFalse } = useDebounceFn(() => setImpact(0), { wait: 2000 })

  usePostUpdatedSubscription({
    variables: {
      postId,
    },
    onSubscriptionData({ subscriptionData }) {
      if (subscriptionData.data) {
        setImpact(Math.round(subscriptionData.data.postUpdated.impact))
        setShowImpactFalse()
      }
    },
  })

  return impact
}
